import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '@/lib/api';

export default function QuotePdfDownloadPage() {
  const { id } = useParams<{ id: string }>();
  const started = useRef(false);
  const [message, setMessage] = useState('De PDF wordt gegenereerd en gedownload…');
  useEffect(() => {
    if (!id || started.current) return;
    started.current = true;
    void api
      .downloadPDF(id)
      .then(() => setMessage('De PDF is gedownload. Je kunt dit venster sluiten.'))
      .catch((error: Error) =>
        setMessage(error.message || 'PDF downloaden mislukt. Open de offerte en probeer opnieuw.')
      );
  }, [id]);
  return (
    <main className="min-h-screen flex items-center justify-center p-6" role="status">
      {message}
    </main>
  );
}
